import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss']
})
export class TablaComponent implements OnInit, OnChanges {

  @Input() datos;
  @Input() cols;
  @Input() showActions: boolean;
  @Input() showInputSwitch: boolean;
  @Input() showEdit: boolean;
  @Input() showDelete: boolean;
  @Input() showAdd: boolean;
  @Input() showSave: boolean;
  @Input() showPaginator: boolean;
  @Input() showRowsPerPage: number = 5;
  @Input() showCheck: boolean;
  @Input() showCheckFondo: boolean;
  @Input() showRadio: boolean;
  @Input() showRadioFondo: boolean;
  @Input() showSearch: boolean;
  @Input() showSort: boolean;
  @Input() showExport: boolean;
  @Input() showCaption: boolean;
  @Input() showPagar: boolean = false;
  @Input() selectedItems;
  @Input() showDeleteTrash: boolean = false;
  @Input() showPedir: boolean = false;
  @Input() showSend: boolean = false;
  @Input() showAlta: boolean = false;
  @Input() showNuevo: boolean = false;
  @Input() showComboPrecio: boolean = false;
  @Input() optionsCombo: any[] = new Array();
  @Input() showMonthPicker: boolean = false;
  @Input() showOjito: boolean = false;

  @Output() emitAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitSelection: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitCalendarSelection: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitMonthSelection: EventEmitter<any> = new EventEmitter<any>();
  fecha: Date = new Date();
  today: Date = new Date();
  mes: Date = new Date();
  es: any;
  opcionElegida;

  constructor(private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Hoy',
      clear: 'Borrar'
    }
  }

  ngOnChanges() {
    
  }

  emitEvent(accion, rowData) {
    this.emitAction.emit({ accion: accion, data: rowData });
  }

  emitirSelection() {
    if (this.selectedItems != null) {
      this.emitSelection.emit(this.selectedItems);
    }
  }

  rowSelection(rowData) {
    this.selectedItems = rowData;
    this.emitirSelection();
  }

  platoDelDia(rowData) {
    if (!isNullOrUndefined(rowData)) {
      return rowData.platoDia && rowData.platoDia === true;
    }
    return false;
  }

  onSelectCalendar() {
    this.emitCalendarSelection.emit(this.fecha);
  }

  onSelectMonth() {
    this.emitMonthSelection.emit(this.mes);
  }

  hayDatos() {
    if (this.datos.length > 0) {
      return true;
    }
    return false;
  }

  changeCombo() {
    this.emitAction.emit(this.opcionElegida);
  }

}
